import { LanguageSchema } from "@/assets/lang";

const nl: LanguageSchema = {
  "title": "Octopus",
  "button": {
    "cancel": "Annuleren",
    "ok": "OK",
    "discardChanges": "Wijzigingen afwijzen",
    "search": "Bladeren",
    "confirm": "Bevestigen",
    "choose": "Selecteer",
    "forward": "Volgende",
    "back": "Terug",
    "reset": "Terug",
    "apply": "Toepassen",
    "login": "Inloggen",
    "logout": "Afmelden",
    "send": "Verzenden",
    "backToStart": "Terug naar start",
    "backToLogin": "Terug naar inloggen",
    "no": "Geen",
    "yes": "Ja",
    "toPayment": "Voor betaling",
    "finishOrder": "Bestelling plaatsen",
    "thank": "Bedanken",
    "sendInvite": "Stuur uitnodiging",
    "resend": "Opnieuw versturen",
    "startNow": "Nu beginnen",
    "skip": "Overslaan",
    "register": "Nu registreren",
    "registerNoCode": "Registreren zonder code",
    "save": "Bespaar",
    "saveChanges": "Wijzigingen toepassen",
    "delete": "{target} verwijderen",
    "addCart": "Toevoegen aan winkelwagentje",
    "orderNow": "Nu bestellen",
    "add": "Toevoegen aan",
    "changePassword": "Wijzig wachtwoord",
    "changeLogin": "Inloggegevens wijzigen",
    "changeEmail": "E-mail wijzigen",
    "edit": "Bewerken",
    "share": "Deel",
    "delivererNotFound": "Leverancier niet gevonden?",
    "joinLocation": "Word lid van team",
    "createLocation": "Locatie aanmaken",
    "editSupplier": "Leverancier @.lower:button.edit",
    "create": "Aanmaken",
    "deleteSupplier": "Leverancier verwijderen",
    "forwardApp": "Ga naar de app",
    "endIntro": "Introductie beëindigen",
    "upload": "Uploaden",
    "showMore": "meer tonen",
    "hide": "verbergen",
    "deleteAll": "Alles verwijderen",
    "settings": "Instellingen",
    "manualSort": "Handmatig sorteren bewerken",
    "switchOldVersion": "Naar de oude versie",
    "goToAppVersion": "Octopus in de browser gebruiken",
    "updateList": "Toevoegen aan lijst",
    "updateCart": "In winkelmand",
    "openCameraScanner": "Scanner met open camera",
    "orderOverview": "Naar het besteloverzicht",
    "deleteSupplierCart": "Winkelmandje verwijderen",
    "resetAmount": "Producthoeveelheden opnieuw instellen",
    "requestAiCall": "AI-oproep aanvragen",
    "filter": {
      "all": "Alles",
      "promotion": "Acties",
      "productSuggestion": "Inspiraties"
    }
  },
  "input": {
    "text": "Tekst",
    "password": "Wachtwoord | Wachtwoorden",
    "email": "E-mail",
    "number": "Nummer",
    "url": "Link",
    "tel": "Telefoon",
    "search": "Zoeken op",
    "date": "Datum",
    "orderDate": "Datum bestelling",
    "datetime": "Datum",
    "datetime-local": "Tijd lokale tijd",
    "month": "Maand",
    "week": "Week",
    "time": "Tijd",
    "range": "Schaal",
    "color": "Kleur"
  },
  "table": {
    "empty": "Tabel selecteert geen elementen"
  },
  "label": {
    "confirm": "bevestigen",
    "pwConfirm": "@:input.password @:label.confirm",
    "newReminder": "Nieuw orderalarm toevoegen",
    "selectPlaceholder": "Selecteer",
    "orderHint": "Opmerking van de leverancier",
    "selectTitle": "Selecteer",
    "date": "@:input.date",
    "time": "Tijd",
    "dateTime": "@:label.date en @:label.time",
    "sum": "Totaal",
    "orderDetails": "Factuurgegevens",
    "promoCode": "Coupon code",
    "orderNumber": "Bestelnummer",
    "octopusId": "Octopus ID",
    "orderMessage": "Bericht van bestelling",
    "description": "Beschrijving",
    "sort": "Sorteren",
    "priceRange": "Prijsklasse",
    "login": "Inloggen",
    "user": "Gebruiker",
    "newEmail": "Nieuwe e-mail",
    "oldPassword": "Oud @:input.password",
    "password": "@:input.password",
    "pwForget": "@:input.password vergeten",
    "contactData": "Contactgegevens",
    "name": "Naam",
    "list": "Lijst",
    "type": "Type",
    "zip": "POSTCODE",
    "city": "Stad",
    "street": "Adres",
    "streetNumber": "Huisnummer",
    "phone": "Telefoon",
    "fax": "Fax",
    "streetName": "Straatnaam",
    "postalCode": "@:label.zip",
    "deliverer": "@:object.deliverer",
    "customerNumber": "Klantnummer/plaats van aankoopnummer",
    "quickstart": "Snelstart code",
    "email": "@:input.email",
    "firstName": "Voornaam",
    "lastName": "Naam",
    "dark": "Donker",
    "light": "Licht",
    "standard": "Systeem instelling",
    "amount": "Hoeveelheid",
    "multipleAmount": "hoeveelheid moet een veelvoud zijn van {target}",
    "maxAmount": "Maximum aantal {target}",
    "standardList": "Standaard lijst",
    "language": "Taal",
    "aiCallLanguage": "Taal",
    "oldMessages": "Ouder nieuws",
    "notification": {
      "allow": "Berichten toestaan"
    },
    "permission": {
      "order": "@:object.order",
      "promotion": "@:object.promotie",
      "message": "@:object.bericht",
      "news": "Nieuws",
      "reminder": "Herinnering",
      "productPromotion": "Product suggesties",
      "sub": {
        "newOrder": "Nieuwe bestellingen",
        "updateStatus": "Update bestellingen",
        "added": "Nieuwe promotie",
        "ending": "Promotie op",
        "general": "Algemeen"
      },
      "mode": {
        "push": "Push bericht",
        "email": "E-mail notificatie",
        "popup": "Pop-up"
      }
    },
    "teamRole": {
      "admin": "Admin",
      "user": "Teamlid Pro",
      "device": "Teamlid basis",
      "OWNER": "Eigenaar"
    },
    "teamRoleShort": {
      "admin": "Admin",
      "user": "Pro",
      "device": "Basis",
      "OWNER": "Eigenaar"
    },
    "support": {
      "general": "Octopus Ondersteuning",
      "gastro": "Team Klantenservice Gastro",
      "technical": "Team Technische Klantenservice",
      "technicalLead": "Technisch leider",
      "distribution": "Gemachtigde, marketing, verkoop",
      "service": "Team Klantenservice"
    },
    "loading": {
      "location": "Laden @:object.location"
    },
    "onAccount": "Factuur",
    "onAccountOrCash": "Factuur of contant geld",
    "ON_ACCOUNT": "@:label.onAccount",
    "UNSPECIFIED": "niet gespecificeerd",
    "CASH": "@:label.cash",
    "cash": "Bar",
    "bar": "Bar / café",
    "office": "Kantoor",
    "coffeeShop": "Café / Bistro",
    "caterer": "Traiteur / kantine / clubs",
    "club": "Club / discotheek",
    "EVENT": "Gebeurtenis",
    "DEALER": "Handelaar",
    "takeAway": "Snackbar / Kiosk / Take-Away",
    "canteen": "Kantine",
    "restaurant": "Restaurant",
    "hotel": "Hotel",
    "spaetshop": "Tankstation / avondwinkel",
    "getraenkehaendler": "Drankhandelaar",
    "getraenkeabholmarkt": "Drankenverzamelmarkt",
    "STAR_GASTRONOMY": "Sterren Gastronomie",
    "SYSTEM_GASTRONOMY": "Systeem catering",
    "spaetShop": "Late winkel",
    "impress": "Opdruk",
    "termsOfUse": "Gebruiksvoorwaarden",
    "agreeAGB1": "Ik ga akkoord met de",
    "agreeAGB2": "Privacybeleid",
    "agreeAGB3": "naar",
    "category": "Categorie",
    "noCategory": "Zonder categorie",
    "editTags": "Eigen categorieën aanmaken",
    "selectDeliverer": "Selecteer @:object.deliverer",
    "threeChars": "Voer ten minste drie tekens in om zoekresultaten te krijgen",
    "offlineMode": "Offline modus",
    "disable": "deactiveren",
    "enable": "activeren",
    "at": "op",
    "atTime": "op",
    "and": "en",
    "customerNo": "Klantnummer",
    "current": "Huidige",
    "tags": "Filter categorieën",
    "ownCategories": "Eigen categorieën",
    "supplierCategories": "Leveranciers categorieën",
    "noFilter": "Geen filter",
    "quantity": "Hoeveelheid",
    "quantityBiggerZero": "Met hoeveelheid",
    "or": "of",
    "delivererType": {
      "online": "Online",
      "offline": "Offline"
    },
    "deleted": "Verwijderd",
    "resetAmount": "Reset producthoeveelheid na bestelling",
    "compatibilityMode": "Compatibiliteitsmodus",
    "timeIssueDelivery": "De door u opgegeven leveringsdatum ligt in het verleden. Kies een latere datum.",
    "timeIssuePickup": "De door u opgegeven ophaaltijd ligt in het verleden. Kies een latere datum.",
    "wait": "Even wachten",
    "day": "Label",
    "month": "Maand",
    "all": "Alle",
    "articleNo": "Artikelnummer",
    "targetStock": "Beoogde hoeveelheid",
    "targetStockShort": "Doel",
    "resetProductQuantity": "Als je de schuifknop activeert, wordt het aantal producten op nul gezet nadat je bestelling met succes is verzonden. Als je deze niet activeert, blijft het productaantal vooraf ingevuld voor de volgende verwerking van je lijst.",
    "offlineMode1": "De offline modus geeft u de mogelijkheid om uw lijst te synchroniseren en te beheren zonder internetverbinding.",
    "offlineMode2": "Wanneer u de offline modus afsluit, worden alle wijzigingen gesynchroniseerd met de server.",
    "darkMode": "Donkere modus",
    "compatibilityText": {
      "activate": "Activeer deze modus als u de producthoeveelheden in uw lijst in de app wilt bewerken, maar de bestelling via het webportaal wilt plaatsen.",
      "webPortal": "Zolang deze modus geactiveerd is, wordt de lijsthoeveelheid gesynchroniseerd met het webportaal en is het niet mogelijk om deze lijst via de app te bestellen.",
      "deactivate": "Deactiveer deze modus als u via de app wilt bestellen."
    },
    "newProductSuggestion": "Nieuw productvoorstel",
    "files": "Bestanden",
    "issue": "Probleem",
    "place": "Locatie",
    "expectation": "Verwachting",
    "steps": "Stappen",
    "availability": "Beschikbaarheid",
    "availableFrom": "Beschikbaar op",
    "deletedLocations": "Verwijderde locaties",
    "reducedListDesign": "Ontwerp met gereduceerde lijst",
    "reducedListDesignDescription": "Het verkorte lijstontwerp verandert de weergave van je lijst. Productafbeeldingen worden verborgen, maar er worden extra knoppen weergegeven voor bediening.",
    "insert": "invoegen",
    "camera": "Camera scanner",
    "scanner": "Scanner",
    "picture": {
      "takePicture": "Maak een foto",
      "selectPicture": "Foto selecteren",
      "editPicture": "Foto bewerken",
      "removePicture": "Afbeelding verwijderen"
    },
    "uncategorized": "Uncategorized",
    "orderDataLoading": "Bestelgegevens worden geladen.",
    "screenshot": "Schermafbeelding",
    "uploadImage": "Afbeelding uploaden",
    "aiCallbackPhone": "Sla telefoonnummer op om terug te bellen"
  },
  "error": {
    "addReminder": "Bestelalarm kon niet aan een lijst worden toegewezen",
    "noMatch": "{target} komt niet overeen",
    "notFound": "{target} werd niet gevonden. | {target} werd niet gevonden.",
    "invalid": "{target} is niet correct. | {target} is niet correct.",
    "empty": "{target} is leeg. | {target} is leeg.",
    "noAuth": "{target} heeft geen toestemming. | {target} heeft geen toestemming.",
    "noAdmin": "Geen beheerdersrechten gevonden.",
    "addCart": "Product kon niet worden toegevoegd aan de winkelwagen. | product kon niet worden toegevoegd aan de winkelwagen.",
    "addPromoPackage": "Het promotiepakket is niet of slechts gedeeltelijk toegevoegd aan het winkelmandje.",
    "addList": "Product kon niet worden toegevoegd aan de lijst. | Product kon niet worden toegevoegd aan de lijst.",
    "create": "{target} kon niet worden aangemaakt. | {target} kon niet worden aangemaakt.",
    "order": "Bestelling kon niet worden verwerkt.",
    "save": "{target} kon niet worden opgeslagen.",
    "delete": "{target} kon niet worden verwijderd.",
    "deleteUser": "Gebruiker kon niet worden verwijderd.",
    "resendMail": "E-mail kon niet opnieuw worden verzonden.",
    "sendLink": "Link kon niet worden verzonden.",
    "removeProduct": "Product kon niet worden verwijderd uit de winkelwagen. | Product kon niet worden verwijderd uit de winkelwagen.",
    "registerFalse": "Registratie is mislukt.",
    "loginFalse": "Inloggen mislukt.",
    "locationFalse": "Aanmaken van locatie mislukt.",
    "orderFinish": "Opdracht kon niet worden aangemaakt.",
    "send": "{target} kon niet worden verzonden.",
    "loadSupplier": "Leverancier kon niet worden geladen | Leveranciers konden niet worden geladen.",
    "loadLists": "Lijsten konden niet worden geladen.",
    "load": "{target} kon niet worden geladen. | {target} kon niet worden geladen.",
    "sendTicket": "De feedback kon niet verzonden worden.",
    "scanBarcode": "De gescande barcode is ongeldig.",
    "promotionLimitReached": "Max. Actie hoeveelheid bereikt",
    "aiCall": "@:error.returnType.Unknown",
    "ajv": {
      "required": "Verplichte velden zijn niet ingevuld",
      "format": "De invoer was niet correct: De invoer moet in het formaat {formatInfo} zijn.",
      "formatInfo": {
        "date": "Datum",
        "time": "Tijd",
        "email": "E-mail",
        "date-time": "Datum en tijd"
      },
      "oneOf": "De invoer komt niet overeen met een van de mogelijke waarden",
      "minimum": "Invoer valt onder minimum van {min}",
      "maximum": "De invoer overschrijdt het maximum van {max}",
      "enum": "De invoer bevat geen van de mogelijke waarden"
    },
    "returnType": {
      "Unknown": "Er is een fout opgetreden",
      "BadRequest": "Verzoek bevat onjuiste gegevens",
      "NotFound": "Verzoek heeft geen element gevonden.",
      "Unauthorized": "Ontbrekende autorisatie",
      "Forbidden": "Verzoek is niet toegestaan",
      "NotImplemented": "Verzoek is niet geïmplementeerd",
      "InvalidLogin": "Ongeldige login",
      "InvalidSession": "Ongeldige sessie",
      "InvalidPassword": "Ongeldig wachtwoord",
      "UserNotFound": "Gebruiker niet gevonden",
      "UserAlreadyExists": "Gebruiker bestaat al",
      "UserEmailAlreadyExists": "Een gebruiker met dit e-mailadres bestaat al",
      "LocationNotFound": "Locatie niet gevonden",
      "CartItemNotFound": "Product niet gevonden",
      "ItemAlreadyInCart": "Product zit al in de winkelwagen, wijzig uw selectie in de winkelwagen",
      "ListAlreadyInCart": "Lijst zit al in de winkelwagen, wijzig uw selectie in de winkelwagen. De lijst kan pas worden bewerkt als deze in de winkelwagen is besteld.",
      "ListCantBeDeleted": "Lijst kan niet worden verwijderd.",
      "ListEmpty": "De lijst is leeg. Controleer of ten minste één product een hoeveelheid van meer dan 0 heeft.",
      "SupplierNotFound": "Leverancier niet gevonden",
      "SupplierItemNotFound": "Leverancier product niet gevonden",
      "OrderNotFound": "Bestelling niet gevonden",
      "ListNotFound": "Lijst niet gevonden",
      "ListItemNotFound": "Lijst product niet gevonden",
      "ItemAlreadyInList": "Product staat al in de lijst, wijzig uw selectie in de lijst",
      "ItemNotFromListSupplier": "Product is niet van leverancier van deze lijst",
      "NotificationNotFound": "Kennisgeving niet gevonden",
      "TagNotFound": "Categorie niet gevonden",
      "TagAlreadyExists": "Categorie bestaat al",
      "UserNotInTeam": "Deze gebruiker zit niet in het team",
      "TokenInvalid": "De ingevoerde code is ongeldig",
      "ReminderNotFound": "De bestelherinnering werd niet gevonden",
      "OwnerCantBeEdited": "De eigenaar mag niet bewerken",
      "PromoCodeInvalid": "Coupon code is niet geldig",
      "PromoCodeInvalidAlreadyExists": "Coupon code is al gebruikt",
      "QuickStartCodeInvalid": "Snelstartcode is ongeldig",
      "SupplierAlreadyExists": "Leverancier bestaat al",
      "SupplierCustomerInvalid": "Locatie leverancier is ongeldig",
      "LocationAlreadyExists": "Locatie bestaat al",
      "JavaApiInternalServerError": "Er is een fout opgetreden",
      "NewsNotFound": "Bericht niet gevonden",
      "OrderMessageTooLong": "Orderbericht overschrijdt maximale lengte",
      "EmailInvalid": "E-mail is ongeldig",
      "TokenInvalidAlreadyUsed": "De ingevoerde code is al gebruikt",
      "SupplierBlocked": "De leverancier is geblokkeerd",
      "PromotionExpired": "Promotionele artikelen verlopen"
    },
    "scannedProductNotAvailable": "Het gescande product is niet beschikbaar in de catalogus van uw leverancier en kan daarom niet worden toegevoegd aan de scannerlijst.",
    "scannerNotAvailable": "Er is geen scanner aangesloten op uw apparaat. Maak verbinding met een scanner of controleer uw bestaande verbinding"
  },
  "error.": "Er is een fout opgetreden",
  "target": {
    "username": "Gebruikersnaam",
    "user": "Gebruiker",
    "userAndPw": "@:doel.gebruikersnaam en @:input.wachtwoord",
    "setting": "Instellingen",
    "profile": "Profiel",
    "location": "Locatie",
    "order": {
      "paypal": "PayPal"
    },
    "product": "Producten",
    "request": "Aanvraag",
    "list": "Lijst",
    "required": "Verplicht veld",
    "field": "Veld | Velden",
    "deliverer": "Leverancier | Leveranciers",
    "tag": "Categorie | Categorieën",
    "password": "Wachtwoord",
    "permission": "Autorisatie | Rechten"
  },
  "messages": {
    "orderFrom": "Bestelling van",
    "mobileWeb": "We hebben gemerkt dat je de Octopus Order webversie probeert te openen vanaf een mobiel apparaat. Voor een betere gebruikerservaring raden wij u aan de mobiele app te downloaden uit uw app store op mobiele apparaten en deze te gebruiken in plaats van de webversie.",
    "mobileWeb2": "De volgende links brengen u naar de Octopus Order mobiele app:",
    "setting": {
      "location": "Wijzig uw locatie",
      "profile": "Bewerk uw gebruikersprofiel",
      "delivererAssign": "Een leverancier aan uw locatie toewijzen",
      "delivererSelect": "Leverancier kiezen",
      "inputCustomerNr": "Klantnummer invoeren",
      "changeLocation": "Locatie wijzigen",
      "welcome1": "Hallo {name}",
      "welcome2": "Hier kunt u kiezen voor",
      "welcome3": "welke weergave u verkiest"
    },
    "emptyCart": "Sorry, uw winkelwagen is leeg.",
    "emptySuggestion": "Sorry, we hebben momenteel geen productsuggesties voor u.",
    "card": {
      "forwardPoints": "Klik hier om doorgestuurd te worden naar ons @:object.pointSystem",
      "points": "Octopus punten",
      "shop": "Naar de Octopus winkel",
      "currentPromotion": "Huidige acties",
      "createLocationExplanation": "Een locatie kan een bar, restaurant, hotel, kantoor of soortgelijke zaak zijn.",
      "productSuggestion": "Productnieuws en suggesties"
    },
    "noPromotion": "Sorry, we hebben momenteel geen promoties voor u.",
    "promotion": {
      "order": "Te bestellen bij",
      "octopus": "Octopus promoties",
      "deliverer": "Promoties van uw leveranciers",
      "articles": "Deze artikelen hebben momenteel een promotieprijs"
    },
    "home": {
      "createLocation": "Nieuw @:messages.location.create",
      "welcome1": "Hallo {name}",
      "welcome2": "welke locatie wilt u?",
      "image1": "Gemixt, getapt, besteld!",
      "image2": "Veilig, digitaal, bestellen!",
      "image3": "Eenvoudig, snel, bezorgen!"
    },
    "dashboard": {
      "catalog": {
        "availableProduct": "Alle beschikbare artikelen",
        "delivererCatalog": "Assortiment van de leverancier",
        "createProduct": "Product toevoegen",
        "createdCustomProduct": "Product is toegevoegd aan de lijst.",
        "noReducedSupplier": "Momenteel biedt geen van je leveranciers deals aan."
      },
      "home": {
        "orders": "Uw laatste bestellingen",
        "favouriteList": "Uw laatst bestelde lijsten",
        "news": "Octopus Nieuws"
      },
      "list": {
        "allLists": "Alle lijsten van deze locatie",
        "createList": "Nieuw @:titleRoute.addList",
        "noSupplier": "U heeft nog geen leverancier aan uw locatie toegevoegd. Voeg een leverancier toe via de instellingen."
      },
      "message": {
        "available": "Nieuws beschikbaar"
      },
      "setting": {
        "order": "Alles over uw bestellingen in één oogopslag",
        "team": "Overzicht en beheer van uw team",
        "deliverer": "Hier ziet u uw leveranciers",
        "notification": "Hier beheert u uw meldingen",
        "display": "Kies tussen donkere of lichte modus",
        "statistic": "Hier kunt u uw evaluaties bekijken",
        "imprint": "Informatie en juridisch",
        "support": "Contact Octopus Orde",
        "orderNotificationTimer": "Stel uw bestelalarm in",
        "intro": "Ontdek alle functies van de app"
      }
    },
    "location": {
      "thank": "@:button.thank",
      "sendMsg": "Bericht sturen",
      "create": "Locatie toevoegen",
      "requestSent": "Uw verzoek aan leverancier {leverancier} wordt bekeken. Een vertegenwoordiger zal de komende dagen contact met u opnemen.",
      "assignDeliverer": "Een leverancier aan uw locatie toewijzen",
      "welcome1": "Hallo {name}",
      "intro": "In 4 korte stappen vullen we samen uw profiel aan"
    },
    "noOrders": "Je hebt nog geen bestellingen geplaatst.",
    "noOrdersFilter": "Je hebt in dit tijdsbestek geen bestellingen geplaatst.",
    "noLists": "U heeft nog geen lijsten aangemaakt.",
    "noNotifications": "U heeft nog geen meldingen ontvangen.",
    "noNews": "Sorry, er is momenteel geen Octopus nieuws beschikbaar.",
    "order": {
      "deliveryType": "Selecteer leveringsmethode",
      "deliveryTime": "Selecteer bezorgdag",
      "pickupTime": "Selecteer afhaaltijd",
      "pickup": "Ophalen",
      "delivery": "Levering",
      "overview": "Overzicht bestellingen",
      "choosePayment": "Betaalmethode kiezen",
      "redirectPayment": "In de volgende stap wordt u doorgestuurd naar {target}.",
      "rememberPayment": "Gebruik de betalingsmethode voor toekomstige bestellingen.",
      "voucher": "Tegoedbon | Tegoedbonnen",
      "redeemVoucher": "@:messages.order.voucher redeem",
      "voucherCode": "Voer voucher code in",
      "currentOrders": "Mijn bestellingen",
      "orderProducts": "Uw bestelde @:object.artikel",
      "otherProducts": "Andere vaak bestelde artikelen",
      "sent": "Uw bestelling is succesvol verzonden naar {target}.",
      "locationIssue": "Ontbrekende afhaallocatie. Voer een afhaallocatie in."
    },
    "deliverer": {
      "allDeliverers": "Alle @:object.deliverer van {location}",
      "addDeliverer": "Voeg een @:object.deliverer toe",
      "noEmail": "Voeg een e-mailadres toe aan de bezorger voordat u kunt bestellen"
    },
    "team": {
      "invite": {
        "welcome1": "@:berichten.home.welkom1",
        "welcome2": "Nodig andere medewerkers of partners uit voor de app...",
        "copy": "Of kopieer gewoon de code en deel hem:",
        "messenger": "Nodig direct uit via de messenger van uw keuze:",
        "mail": "Per e-mail",
        "joinTeam": "Word lid van ons team",
        "joinTeam2": "Je bent uitgenodigd op de locatie {location} in de Octopus Bestel App!\n\nMet deze link kun je direct lid worden van je team.\n\n{inviteLink}\n\nAls deze link niet werkt, kun je lid worden van je team in de app met de code\n\n{link}\n\nom lid te worden van je nieuwe team.\n\nVoor Android: {appLinkAndroid}\n\nVoor IOS: {appLinkIOS}",
        "shareHint": "Om veiligheidsredenen kan de gegenereerde/verstuurde code alleen basisgebruikers uitnodigen. Gebruik de e-mailuitnodiging voor een uitnodiging met de geselecteerde rechten."
      },
      "management": {
        "members": "Teamleden van {location}",
        "inviteMember": "Teamleden uitnodigen",
        "addDevice": "Apparaat toevoegen",
        "permissionExplanation": "Overzicht van de rechten van onze rollen:"
      }
    },
    "missingPermission": "Ontbrekende toestemming: {permission}",
    "missingCartOrderPermission": "Je rechten in de app zijn niet voldoende. Neem contact op met de eigenaar van uw locatie om een bestelling te voltooien.",
    "permission": {
      "all": "Alle rechten",
      "locationOrderHistoryRead": "Bestelgeschiedenis lezen",
      "locationListRead": "Lijsten bekijken",
      "locationListItemRead": "Bekijk lijst producten",
      "locationListItemCreate": "Lijstproducten aanmaken",
      "locationListItemUpdate": "Lijstproducten bewerken",
      "locationListItemDelete": "Lijstproducten verwijderen",
      "locationListCreate": "Lijsten maken",
      "locationListUpdate": "Lijsten bewerken",
      "locationListDelete": "Lijsten verwijderen",
      "locationCartRead": "Winkelwagentje bekijken",
      "locationCartAdd": "Winkelwagen vullen",
      "locationCartUpdate": "Producten in winkelwagentje bewerken",
      "locationCartDelete": "Producten uit winkelwagentje verwijderen",
      "locationOrderCreate": "Bestelling aanmaken",
      "locationOrderRequest": "Bestellingsaanvraag uitvoeren",
      "locationRead": "Locatie bekijken",
      "locationCreate": "Locatie aanmaken",
      "locationUpdate": "Locatie bewerken",
      "locationDelete": "Locatie verwijderen",
      "locationTeamRead": "Bekijk team",
      "locationTeamMemberAdd": "Teamlid toevoegen",
      "locationTeamMemberDelete": "Teamlid verwijderen",
      "locationTeamMemberRoleUpdate": "Rollen van teamleden bewerken",
      "locationSupplierRead": "Leveranciers bekijken",
      "locationSupplierCreate": "Leveranciers toevoegen",
      "meRead": "Eigen gebruikersgegevens lezen",
      "meUpdate": "Eigen gebruikersgegevens bewerken",
      "meDelete": "Eigen gebruiker verwijderen",
      "locationListReminderCreate": "Bestelalarm aanmaken",
      "locationListReminderDelete": "Bestelalarm verwijderen",
      "locationListReminderRead": "Bestelling alarm bekijken",
      "locationListReminderUpdate": "Order alarm bewerken",
      "locationContactSupplier": "Contact opnemen met leverancier"
    },
    "noListEntries": "Er zijn momenteel geen items in deze lijst",
    "noSearchResults": "Geen artikelen gevonden voor uw filter",
    "noEntries": "Geen artikelen beschikbaar",
    "noMail": "Geen mail ontvangen",
    "login": {
      "emailSent": "We hebben u zojuist een e-mail gestuurd",
      "setPassword": "U kunt een nieuw wachtwoord instellen via de link",
      "resetPassword": "Vul uw e-mailadres in en ontvang een nieuw wachtwoord"
    },
    "start": {
      "notNew": "Reeds klant",
      "new": "Eerste keer hier"
    },
    "cart": {
      "amount": "{amount} Item posities",
      "selectionFrom": "Selectie bij {leverancier}",
      "fromList": "Van uw lijsten",
      "noList": "Zonder lijst",
      "lastOrder": "Van uw laatste bestelling",
      "amountItems": "{amount} Enkel artikel",
      "upgradeToPromotion": "We zijn er bijna! Nog maar {amount} Stukken tot de {shortTitle} Actie 🏷️ → bestel nu",
      "convertToPromotion": "Actie beveiligd 🏷️ → nu activeren"
    },
    "register": {
      "intro": "Om uw profiel aan te maken hebben we enkele gegevens nodig",
      "thank": "Dank u {name}",
      "emailSent": "@:messages.login.emailSent",
      "validate": "Gelieve uw account te bevestigen via de link",
      "validateEmail": "@:{'messages.register.validate'} verzonden naar uw e-mailadres voordat u kunt bestellen",
      "noCode": "Ik heb geen uitnodigingscode",
      "code": "Ik heb een uitnodigingscode ontvangen",
      "skipEmail": "Helaas konden we het ingevoerde e-mailadres niet vinden. Bevestig uw e-mailadres nogmaals."
    },
    "didYouMean": "Bent u toevallig op zoek naar {target}?",
    "didYouCheck": "Heeft u in de vorige weergave alle leveranciers gezocht?",
    "agbRequired": "U moet akkoord gaan met het privacybeleid.",
    "list": {
      "repeatEach1": "Herinnering",
      "repeatEach2": "Alle",
      "noTags": "Geen filtercategorieën beschikbaar. Voeg categorieën toe aan uw lijst producten.",
      "overrideCartList": "De lijst zit al in het winkelwagentje. Wilt u het winkelwagentje overschrijven?",
      "overrideProductList": "Dit product zit al in je winkelmandje. Wilt u uw winkelwagentje overschrijven?",
      "noReminder": "Er zijn nog geen bestelalarmen gemaakt voor deze lijst.",
      "amountReset": "De producthoeveelheden zijn opnieuw ingesteld.",
      "resetCheck": "Weet je zeker dat je alle hoeveelheden in deze lijst op 0 wilt zetten?"
    },
    "pressEnter": "Bevestig op toetsenbord om toe te voegen",
    "changedEmail": "We hebben u zojuist een e-mail gestuurd naar het nieuwe adres. Klik op de verzonden link om de wijziging toe te passen.",
    "updateLoading": "Update wordt geïnstalleerd",
    "intro": {
      "home": {
        "msg1": "Klik op de kop om terug te keren naar uw locatieoverzicht en winkelwagen.",
        "title1": "Bereik uw locaties en de winkelwagen",
        "msg2": "Uw meest recente bestellingen en veel bestelde lijsten zijn direct toegankelijk via het dashboard.",
        "title2": "Overzicht van uw activiteiten",
        "msg3": "Gebruik de menubalk om met één klik uw bestemming te bereiken.",
        "title3": "Overal toegankelijke navigatie"
      },
      "list": {
        "title1": "De volgorde begint hier",
        "msg1": "Via de header heeft u toegang tot uw lijsten en de catalogus. Hier kunt u de artikelen van uw leveranciers doorzoeken.",
        "title2": "Uw leveranciers",
        "msg2": "Hier kunt u de bestellijsten van uw leveranciers bekijken en bewerken of zelf nieuwe lijsten aanmaken.",
        "title3": "Sorteren en verwijderen",
        "msg3": "Tik op de productafbeelding om één of meerdere artikelen te selecteren, ze te verplaatsen met slepen en neerzetten of ze te verwijderen met het prullenbakpictogram.",
        "title4": "De lijst eenvoudig aanpassen",
        "msg4": "De hoeveelheid van een product kan worden gewijzigd met de plus- en min-knoppen. Veeg naar rechts om het product uit de lijst te verwijderen.",
        "title5": "Snel artikelen vinden",
        "msg5": "In de catalogus kunt u de individuele items van uw leveranciers bekijken en zoeken en filteren op categorie."
      },
      "promotion": {
        "title1": "Promoties en suggesties",
        "msg1": "Hier ziet u actuele promoties, productsuggesties of nieuws van uw leveranciers of van Octopus Order.",
        "title2": "Promoties van uw leveranciers",
        "msg2": "Hier ziet u artikelen van uw leveranciers waarvoor momenteel speciale aanbiedingen beschikbaar zijn.",
        "title3": "Actuele suggesties en nieuws",
        "msg3": "Bij de productsuggesties krijgt u informatie over de laatste trends in de drankenindustrie. In de nieuwssectie vindt u al het laatste nieuws over Octopus."
      },
      "setting": {
        "msg1": "Hier kunt u uw leveranciers en locaties beheren, instellingen maken, bestellingen bekijken of contact opnemen met support.",
        "title1": "App instellingen",
        "msg2": "U kunt hier alarmen instellen om u er regelmatig aan te herinneren uw lijst te bestellen.",
        "title2": "Nooit meer een bestelling vergeten",
        "msg3": "Hier kunt u uw team beheren en andere teamleden uitnodigen voor Octopus Order.",
        "title3": "Uw eigen team",
        "msg4": "Hier heeft u een overzicht van al uw leveranciers en kunt u ze bewerken of verwijderen en nieuwe leveranciers toevoegen.",
        "title4": "Overzicht leveranciers"
      }
    },
    "ordering": "Bestelling wordt uitgevoerd",
    "noConnection1": "Geen verbinding met server",
    "noConnection2": "Controleer uw internetverbinding",
    "switchLocation": "De melding hoort bij een andere locatie. Wilt u de locatie wijzigen?",
    "containsExpiredPromotion": "Er bevindt zich een verlopen promotieartikel in je winkelwagentje. Verwijder het om door te gaan met je bestelling.",
    "addProductsViaScanner": "Producten toevoegen via scanner",
    "scanDesiredProducts": "Scan de gewenste producten",
    "scanToAddMoreProducts": "Scannen om meer producten toe te voegen",
    "updateScanItems": "Wil je je gescande items toevoegen aan je lijst? Het aantal items in de lijst wordt overschreven.",
    "addScanItems": "Wilt u uw gescande artikelen toevoegen aan het winkelmandje?",
    "holidayDeliveryTitle": "De geselecteerde leveringsdag is een feestdag!",
    "holidayDelivery": "Vraag uw leverancier naar de exacte leverdatum.",
    "longOrder": "Je bestelling is meer dan zeven dagen in de toekomst. Wil je echt op {date} bestellen?",
    "cartDataMissing": "Bestelgegevens onjuist",
    "newBinaryVersion": "Er is een nieuwe versie beschikbaar met belangrijke wijzigingen. Werk uw versie bij.",
    "deliveryDayWarningTitle": "De geselecteerde datum is geen normale bezorgdag!",
    "deliveryDayWarning": "Bespreek uitzonderlijke gevallen vooraf met de leverancier.",
    "holidayPickupTitle": "De geselecteerde ophaaldag is een feestdag!",
    "holidayPickup": "Vraag uw leverancier naar de exacte ophaaldatum.",
    "modal": {
      "updateLocationTypeTitle": "Jouw keuze, jouw voordeel",
      "updateLocationTypeDescription": "Wanneer je je cateringbedrijf selecteert, passen we de inhoud en promoties voor je aan. Je kunt deze instelling op elk moment wijzigen.",
      "updateLocationTypeHint": "De selectie wordt alleen binnen de app gebruikt en kan op elk moment worden aangepast."
    },
    "currentLocation": "U bevindt zich momenteel op de locatie"
  },
  "object": {
    "order": "Bestelling | Bestellingen",
    "article": "Item posities",
    "promotion": "Actie | Acties",
    "location": "Plaats",
    "cart": "Winkelwagen",
    "list": "Lijst | Lijsten",
    "filter": "Filter",
    "message": "Nieuws | Nieuws",
    "catalog": "Catalogus",
    "notification": "Kennisgeving | Kennisgevingen",
    "notificationOption": "@:object.notification{'soptions'}",
    "setting": "Instellingen",
    "intro": "Apptour",
    "home": "Home",
    "dark": "Donker",
    "light": "Licht",
    "zip": "POSTCODE",
    "city": "Stad",
    "street": "Straat",
    "lastname": "Naam",
    "firstname": "Voornaam",
    "address": "Adres",
    "zipCity": "@object:postcode, @object:woonplaats",
    "profile": "Profiel",
    "pointSystem": "Puntensysteem",
    "amount": "Hoeveelheid",
    "price": "Prijs per eenheid",
    "total": "Totale prijs",
    "notAvailable": "Prijsinformatie niet beschikbaar",
    "sort": "Sorteren",
    "alphabetic": "Alfabetisch",
    "filterCategory": "@:object.filter{'categorie'}",
    "priceRange": "Prijsklasse",
    "team": "Team",
    "deliverer": "Leverancier | Leveranciers",
    "display": "Weergave opties",
    "statistic": "Statistieken",
    "imprint": "Afdruk",
    "law": "Juridisch",
    "support": "Octopus Orderondersteuning",
    "filterOption": {
      "spirits": "Geesten",
      "nonAlcoholic": "Niet-alcoholische dranken",
      "beer": "Bier",
      "gastro": "Gastronomische behoeften",
      "wine": "Wijn",
      "food": "Voedsel",
      "nonFood": "Niet-voeding",
      "other": "Overige"
    },
    "suggestion": "Product{suggestie} | Product{suggestie}",
    "news": "Nieuws",
    "days": "Dagen | Dag",
    "hours": "Uren | Uur",
    "minutes": "Minuten | Minuut",
    "validFor": "Geldig voor {waarde}",
    "validUntil": "Geldig tot",
    "expired": "Verlopen op",
    "totalPosition": "Totale positie",
    "totalOrder": "Totale bestelwaarde"
  },
  "enumT": {
    "pinned": "Gepend",
    "new": "Nieuw",
    "restocked": "Weer beschikbaar",
    "reduced": "Op aanbieding",
    "notInStock": "Met levertijd",
    "promotion": "Promotionele artikelen",
    "issueType": {
      "bug": "Bug",
      "feature": "Feature"
    },
    "contactWay": {
      "none": "Neem geen contact op met",
      "email": "E-mail",
      "phone": "Telefoon",
      "emailOrPhone": "E-mail of telefoon"
    },
    "sortDirection": {
      "asc": "Oplopend alfabetisch",
      "desc": "Alfabetisch aflopend",
      "catFilter": "Per eigen categorie",
      "catSupplier": "Op categorie leverancier",
      "manually": "Handmatig sorteren"
    },
    "weekday": {
      "mon": "Maandag",
      "tue": "Dinsdag",
      "wed": "woensdag",
      "thu": "Donderdag",
      "fri": "Vrijdag",
      "sat": "zaterdag",
      "sun": "Zondag"
    },
    "repeatCycle": {
      "once": "uniek",
      "week": "wekelijks",
      "month": "maandelijks",
      "appendix": {
        "week": "week(en)",
        "month": "maand(en)"
      }
    },
    "month": {
      "january": "januari",
      "february": "Februari",
      "march": "Maart",
      "april": "April",
      "may": "Mei",
      "june": "Juni",
      "july": "Juli",
      "august": "Augustus",
      "september": "september",
      "october": "Oktober",
      "november": "November",
      "december": "december"
    }
  },
  "modal": {
    "selection": "Keuzes",
    "addList": "Toevoegen aan de lijst",
    "addCart": "Toevoegen aan winkelwagentje",
    "openCatalog": "Openen in catalogus"
  },
  "success": {
    "addReminder": "Bestelling wekker is toegevoegd",
    "editReminder": "Bestelling wekker opgeslagen",
    "deleteReminder": "Bestelwekker werd verwijderd",
    "addCart": "Product is toegevoegd aan de winkelwagen. | Product is toegevoegd aan de winkelwagen",
    "addPromoPackage": "Promotiepakket is toegevoegd aan het winkelmandje.",
    "addCartNumber": "{target} Enkele items van {target2} itemposities werden toegevoegd aan de winkelwagen",
    "addList": "Product is toegevoegd aan de lijst. | Producten zijn toegevoegd aan de lijst.",
    "order": "Lijst is besteld.",
    "save": "{target} is succesvol opgeslagen. | {target} is succesvol opgeslagen.",
    "resendMail": "E-mail is opnieuw verzonden.",
    "copyLink": "Link werd gekopieerd",
    "sendLink": "Link werd verzonden.",
    "removeProduct": "Product is verwijderd uit de winkelwagen. | Product is verwijderd uit de winkelwagen.",
    "orderFinish": "Bestelling is aangemaakt.",
    "delete": "{target} is verwijderd.",
    "deleteUser": "Gebruiker is verwijderd",
    "deleteMulti": "{amount} {target} is verwijderd.",
    "send": "{target} is verzonden.",
    "create": "{target} is aangemaakt.",
    "edit": "{target} is succesvol bewerkt.",
    "add": "{target} is toegevoegd.",
    "deleteTeam": "Gebruiker is verwijderd door het team.",
    "setRole": "Gebruikersrol werd succesvol ingesteld",
    "joinLocation": "Locatie werd succesvol toegevoegd",
    "sendInvite": "Uitnodigingsmail is verzonden.",
    "sendTicket": "We hebben uw feedback ontvangen. Hartelijk dank.",
    "aiCall": "De Octobot zal u binnenkort bellen."
  },
  "success.": "Campagne geslaagd",
  "alert": {
    "delete": {
      "account": "Wil je je account en alle bijbehorende locaties definitief verwijderen?",
      "reminder": "Wilt u dit bestelalarm echt verwijderen?",
      "location": "Wilt u deze locatie echt verwijderen?",
      "list": "Wilt u echt de lijst \"{target}\" verwijderen?",
      "noList": "Wilt u alle producten uit uw winkelmandje verwijderen?",
      "cartSupplier": "Wilt u uw winkelmandje legen op \"{target}\"?",
      "cartProduct": "Wilt u echt het product \"{target}\" uit de winkelwagen verwijderen?",
      "cartList": "Wilt u echt de lijst \"{target}\" en alle gerelateerde items uit de winkelwagen verwijderen?",
      "product": "Wilt u echt het product \"{target}\" uit de lijst verwijderen? | Wilt u echt de geselecteerde producten uit de lijst verwijderen?",
      "supplier": "Wilt u {name} uit uw leveranciers verwijderen? Let op: Het verwijderen van een leverancier verwijdert ook alle lijsten voor deze leverancier.",
      "member": "Wilt u echt {target}\" uit het team verwijderen?",
      "tag": "Wilt u \"{target}\" echt uit uw categorieën verwijderen?",
      "customSupplier": "Wilt u deze leverancier echt verwijderen?",
      "scanProduct": "Wilt u echt het product \"{target}\" verwijderen uit uw gescande items?"
    },
    "delivererSuccess": "De leverancier is succesvol toegevoegd",
    "delivererError": "Fout",
    "delivererSuccessMessage": "We hebben {target} toegevoegd aan uw locatie.",
    "delivererErrorMessage": "{target} kon niet worden toegevoegd aan uw locatie. Controleer de ingevoerde gegevens.",
    "selectList": "Kies een lijst",
    "selectSupplier": "Kies een leverancier",
    "noList": "Geen lijst beschikbaar voor deze leverancier.",
    "noSupplier": "Geen leverancier beschikbaar voor dit item",
    "discardFormTitle": "Opgelet!",
    "noInternet": "Niet alle offline gegevens konden worden gesynchroniseerd. Controleer uw internetverbinding.",
    "compatibilityMode": "U heeft de compatibiliteitsmodus geactiveerd. Zolang deze actief is, kunt u alleen via het webportaal bestellen. Uw opgegeven hoeveelheid staat nu in de winkelwagen. Als u via de app wilt bestellen, deactiveert u deze modus in de lijstinstellingen.",
    "discardForm": "Uw gegevens worden niet opgeslagen. Toch de pagina verlaten?",
    "syncing": "Lijsten worden gesynchroniseerd",
    "logout": "Wil je je echt uitschrijven?",
    "upgradeToPromotion": "Promotie nu gebruiken? Hoeveelheid wordt automatisch aangepast aan minimumhoeveelheid ({target})",
    "convertToPromotion1": "Actie toepassen?",
    "convertToPromotion2": "{target1} Promotieartikel, {target2} regulier",
    "orderAmountOverLimit": "Limiet bereikt: {isAmount} Promotieartikel in winkelmandje. Max. +{availableAmount} mogelijk",
    "scannerNotActivated": "De scannerfunctie wordt momenteel niet ondersteund door uw leveranciers!",
    "scannerAvailableOnlyInApp": "De scannerfunctie is alleen beschikbaar in de app!",
    "addLastOrderToCart": "Wil je alle artikelen en hoeveelheden van je laatste bestelling opnieuw in het winkelmandje plaatsen?"
  },
  "titleRoute": {
    "locationData": "Locatie aanmaken",
    "locationCreate": "@:titleRoute.locationData",
    "locationDeliverer": "Selecteer leverancier",
    "locationAdd": "Locatie toevoegen",
    "locationJoin": "Aanmelden locatie",
    "addLocationDeliverer": "Leverancier toevoegen",
    "editLocationDeliverer": "Leverancier bewerken",
    "settingProfile": "Profiel",
    "settingLocation": "Locatie bewerken",
    "settingOrder": "Bestelling | Bestellingen",
    "settingOrderDetail": "Details bestelling",
    "settingTeam": "Team",
    "settingTeamInvite": "Team uitnodigen",
    "settingDeliverer": "Leveranciers",
    "settingDelivererSelect": "Kies leverancier",
    "settingNotification": "Kennisgevingen",
    "settingDisplay": "Weergave opties",
    "settingSupport": "Ondersteuning",
    "settingLegal": "Juridisch",
    "cart": "Winkelwagen",
    "orders": "Bestellingen",
    "filter": "Filter",
    "addList": "Lijst aanmaken",
    "editList": "Lijst bewerken",
    "notificationDetails": "@:titleRoute.settingNotification",
    "orderNotificationTimer": "Alarm bestellen",
    "changePassword": "Wachtwoord wijzigen",
    "addProduct": "Product toevoegen",
    "editProduct": "Product bewerken",
    "agb": "Privacybeleid",
    "news": "Octopus Nieuws",
    "suggestion": "Product voorstel",
    "productDetails": "Productgegevens",
    "promotionDetails": "Actie details",
    "productPresentation": "@:titleRoute.productDetails",
    "promotion": "@:titleRoute.promotionDetails",
    "settingIntro": "Apptour",
    "feedback": "Maak feedback",
    "scanner": "Scanner",
    "skipEmail": "Verificatie per e-mail",
    "deleteLocations": "Verwijderde locaties",
    "aiCall": "AI-bevel"
  },
  "placeholder": {
    "search": "Zoeken",
    "selectSize": "Selecteer grootte",
    "selectVariant": "Selecteer variant",
    "location": {
      "name": "Naam van uw locatie",
      "type": "Type locatie",
      "zip": "Postcode",
      "ownZip": "Postcode van je eigen locatie",
      "city": "Stad",
      "street": "Straat",
      "streetNumber": "Nee.",
      "phone": "Telefoon",
      "internationalPhone": "Internationaal telefoonnummer",
      "deliverer": "@:select object.deliverer",
      "customerNumber": "@:label.customerNumber invoeren"
    },
    "email": "Email",
    "newEmail": "Nieuw e-mail",
    "oldPassword": "Oud @:input.password",
    "password": "@:input.password",
    "passwordRepeat": "@:input.password herhalen",
    "sendMessageDeliverer": "Stuur een bericht naar {deliverer} ...",
    "inviteCode": "Uitnodigingscode invoeren",
    "firstName": "@:label.voornaam",
    "lastName": "@:label.lastName",
    "name": "Naam",
    "phone": "@:placeholder.location.phone",
    "street": "Straat",
    "zip": "POSTCODE",
    "city": "Stad",
    "alphabetic": "Alfabetisch",
    "customerNumber": "Klantnummer",
    "customerNumberPlus": "Klantnummer/Verkoopnummer",
    "quickstart": "Snelstartcode",
    "paymentMethod": "Betaalmethode",
    "pickupMethod": "Locatie",
    "deliveryDate": "Datum levering",
    "emailOrPhone": "@:placeholder.email",
    "code": "Code uitnodiging",
    "packaging": "Pakketgrootte",
    "searchOrAdd": "Categorie zoeken of toevoegen",
    "tagName": "Naam categorie",
    "pickupLocation": "Ophalen in",
    "pickupDate": "Tijdstip ophalen",
    "quantity": "Hoeveelheid",
    "eancode": "EAN-code",
    "customSupplierType": "Type leverancier",
    "issueType": "Type terugmelding",
    "title": "Titel",
    "bug": {
      "issue": "Wat is het probleem?",
      "place": "Waar doet het probleem zich voor?",
      "expectation": "Welk gedrag zou u verwachten in plaats van het huidige gedrag?",
      "steps": "Welke stappen werden genomen tot de bug zich voordeed? / Hoe kan de bug gereproduceerd worden?"
    },
    "feature": {
      "expectation": "Welke extra functie zou u willen zien?",
      "place": "Waar mist u de gewenste functie?"
    },
    "select": "Selecteer",
    "contactWay": "Hoe kunnen we contact met je opnemen voor vragen en updates?"
  },
  "option": {
    "industry": {
      "PRIVATE": "Privé",
      "GETRAENKEFACHGROSSHANDEL": "Dranken groothandel",
      "LEBENSMITTEL_GROSSHANDEL": "Voedingsmiddelen groothandel",
      "HANDELSWAREN_ALLGEMEIN": "Algemene goederen",
      "SONSTIGE": "Overige"
    },
    "customSupplierType": {
      "meat": "Vlees leverancier",
      "vegetable": "Groenten",
      "drinks": "Dranken",
      "hygiene": "Hygiëne artikelen",
      "other": "Overige"
    }
  }
}

export default nl;